import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\CreateInvoiceForInvoiceableController::__invoke
* @see app/Http/Controllers/Dossier/CreateInvoiceForInvoiceableController.php
* @route '/api/dossier/{dossier}/person/{person}/invoice'
*/
const CreateInvoiceForInvoiceableController = (args: { dossier: string | number | { id: string | number }, person: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, person: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateInvoiceForInvoiceableController.url(args, options),
    method: 'post',
})

CreateInvoiceForInvoiceableController.definition = {
    methods: ["post"],
    url: '/api/dossier/{dossier}/person/{person}/invoice',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\CreateInvoiceForInvoiceableController::__invoke
* @see app/Http/Controllers/Dossier/CreateInvoiceForInvoiceableController.php
* @route '/api/dossier/{dossier}/person/{person}/invoice'
*/
CreateInvoiceForInvoiceableController.url = (args: { dossier: string | number | { id: string | number }, person: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, person: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            person: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        person: typeof args.person === 'object'
        ? args.person.id
        : args.person,
    }

    return CreateInvoiceForInvoiceableController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{person}', parsedArgs.person.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\CreateInvoiceForInvoiceableController::__invoke
* @see app/Http/Controllers/Dossier/CreateInvoiceForInvoiceableController.php
* @route '/api/dossier/{dossier}/person/{person}/invoice'
*/
CreateInvoiceForInvoiceableController.post = (args: { dossier: string | number | { id: string | number }, person: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, person: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateInvoiceForInvoiceableController.url(args, options),
    method: 'post',
})

export default CreateInvoiceForInvoiceableController